import * as yup from 'yup';

export const RelatedPartyValidationSchema = yup.object({

    riskId: yup.number().required('Risk is required').typeError('Risk is required').nullable(),
    
    userInSystem: yup.boolean(),

    relatedPartyTo: yup.string().when('userInSystem', {
        is: true,
        then: yup.string().required('Related Party To is required').typeError('Related Party To is required').nullable(),
        otherwise: yup.string().transform((curr, orig) => (orig === '' ? null : curr)).nullable()
    }),

    relationship: yup
        .string()
        .nullable()
        .max(500, 'Max character limit of 500 reached')
        .required('Relationship is required'),

    riskMitigated: yup
        .string()
        .nullable()
        .max(500, 'Max character limit of 500 reached')
        .required('Risk Mitigated is required'),
});
